import { render, staticRenderFns } from "./LabPicture.vue?vue&type=template&id=5b4e7bb8&"
import script from "./LabPicture.vue?vue&type=script&lang=js&"
export * from "./LabPicture.vue?vue&type=script&lang=js&"
import style0 from "./LabPicture.vue?vue&type=style&index=0&id=5b4e7bb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports